import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login          from "./pages/Login";
import Register       from "./pages/Register";
import VerifyOTP      from "./pages/VerifyOTP";
import SelectLanguage from "./pages/SelectLanguage";
import Dashboard      from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import Profile        from "./pages/Profile";
import ShareView      from "./pages/ShareView";
import Tutorial       from "./pages/Tutorial";
import Survey         from "./pages/Survey";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" />;
};

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/"                element={<Login />} />
        <Route path="/register"        element={<Register />} />
        <Route path="/verify-otp"      element={<VerifyOTP />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/share/:shareId"  element={<ShareView />} />

        <Route path="/select-language" element={<ProtectedRoute><SelectLanguage /></ProtectedRoute>} />
        <Route path="/dashboard"       element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/profile"         element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/tutorial"        element={<ProtectedRoute><Tutorial /></ProtectedRoute>} />
        <Route path="/survey"          element={<ProtectedRoute><Survey /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;